import { RetailerPrivilege } from 'helpers/team-user-roles';
import { NavigationLink } from '../../../retailer-platform/brand-shop/brand-shop-tertiary-navigation/types';
import { FcProductSuites } from '../../../retailer-platform/brands/types';

export const tertiaryNavigationLinks: NavigationLink[] = [
    {
        label: 'BRAND_PANEL.MARKETING_MATERIAL',
        id: 'Content > Marketing Material',
        e2eHook: 'sidebar-marketing-files',
        privileges: {
            retailer: [
                RetailerPrivilege.Admin,
                RetailerPrivilege.MarketingManager,
                RetailerPrivilege.Buyer,
                RetailerPrivilege.Viewer
            ]
        },
        route: {
            target: `${FcProductSuites.Content}/marketing`,
            routerLinkActiveOptions: {
                paths: 'subset',
                matrixParams: 'subset',
                queryParams: 'ignored',
                fragment: 'ignored'
            }
        }
    },
    {
        label: 'BRAND_PANEL.PRODUCT_IMAGES',
        id: 'Content > Product Images',
        e2eHook: 'sidebar-products',
        route: {
            target: `${FcProductSuites.Content}/products`
        },
        privileges: {
            retailer: [
                RetailerPrivilege.Admin,
                RetailerPrivilege.MarketingManager,
                RetailerPrivilege.Buyer,
                RetailerPrivilege.Viewer
            ]
        }
    },
    {
        label: 'BRAND_PRODUCTS.BULK_SEARCH_LINK',
        e2eHook: 'navigation-bulk-download',
        id: 'Content > Multi Download',
        privileges: {
            retailer: [RetailerPrivilege.Admin, RetailerPrivilege.MarketingManager, RetailerPrivilege.Buyer]
        },
        route: {
            target: `${FcProductSuites.Content}/products/bulk-gtin-search`
        }
    }
];

export const ITEMS_PER_PAGE_CONTENT = 50;
export const MAX_GTIN_DOWNLOAD_LIMIT = 1000;
export const MAX_ARTICLE_NUMBER_DOWNLOAD_LIMIT = 500;

export enum TranslationKeys {
    BRANDS = 'CONTENT_PAGE_SUMMARY_BAR.BRANDS',
    ARTICLES = 'CONTENT_PAGE_SUMMARY_BAR.ARTICLES',
    MARKETING_FILES = 'CONTENT_PAGE_SUMMARY_BAR.MARKETING_FILES',
    DOWNLOAD = 'CONTENT_PAGE_SUMMARY_BAR.DOWNLOAD',
    DOWNLOAD_IMAGES = 'CONTENT_PAGE_SUMMARY_BAR.DOWNLOAD_IMAGES',
    DOWNLOAD_ATTRIBUTES_CSV = 'CONTENT_PAGE_SUMMARY_BAR.DOWNLOAD_ATTRIBUTES_CSV',
    DOWNLOAD_IMAGES_ATTRIBUTES_CSV = 'CONTENT_PAGE_SUMMARY_BAR.DOWNLOAD_IMAGES_ATTRIBUTES_CSV',
    VIEW_LIST = 'CONTENT_PAGE_SUMMARY_BAR.VIEW_LIST',
    DOWNLOAD_LIST = 'CONTENT_PAGE_SUMMARY_BAR.DOWNLOAD_LIST'
}
